import ProjectSlider from 'components/common/slider/ProjectSlider';
import CustomText from 'components/common/text/CustomText';
import { checkError } from 'lib/clinic/library';
import { indicationOptionList } from 'lib/clinic/mapper';
import {
  ICreateOptionValue,
  IOptionInfo,
  IOptionSliderType,
  IOptionUi,
} from 'lib/types/clinic/projectTypes';
import { TValue } from 'lib/types/common';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface ProjectOptionSliderProps {
  type: 'default' | 'advanced';
  optionValues: ICreateOptionValue;
  optionInfoList: IOptionInfo | null;
  onOptionChange: (type: 'default' | 'advanced', optionKey: string, value: TValue) => void;
}

const ProjectOptionSlider = ({
  type,
  optionValues,
  optionInfoList,
  onOptionChange,
}: ProjectOptionSliderProps) => {
  // SECTION: declare hooks
  const { t } = useTranslation();

  return (
    <StyledProjectOptionSlider>
      {useMemo(
        () =>
          !!indicationOptionList.slider &&
          indicationOptionList.slider.map((option: IOptionUi) => {
            if (!optionInfoList) return;

            const { key: optionKey, title: optionLabel } = option;
            const optionValue = optionValues[optionKey]?.value;
            const optionInfo: IOptionSliderType = optionInfoList[optionKey];

            if (checkError(optionValue) || !optionInfo) return;

            return (
              <div className="projectOptionBasic__item_box" key={option.key}>
                <div className="projectOptionBasic__title">
                  <CustomText fontSize={20} fontWeight={600} fontColor="#222">
                    {t(optionLabel)}
                  </CustomText>
                </div>
                <div className="projectOptionBasic__content">
                  <ProjectSlider
                    value={Number(optionValue) || 0}
                    max={optionInfo.maxValue}
                    min={optionInfo.minValue}
                    step={optionInfo.stepSize}
                    onChange={(value: TValue) => {
                      onOptionChange(type, optionKey, value);
                    }}
                    isValueInput
                  />
                </div>
              </div>
            );
          }),
        [optionValues, optionInfoList],
      )}
    </StyledProjectOptionSlider>
  );
};

const StyledProjectOptionSlider = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  margin-bottom: 30px;
  .projectOption__item_box {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    .projectOption__title {
      width: 163px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .projectOption__content {
      width: 100%;
      display: flex;
    }
  }
`;

export default ProjectOptionSlider;
